import { BillConceptos } from '../../../models/Factura';

/** Blank concepto, pre-filled with the fixed values a global bill requires */
export const EMPTY_CONCEPTO = (isGlobalBill = false): BillConceptos => (JSON.parse(JSON.stringify({
    claveProdServ: isGlobalBill ? '01010101' : '',
    claveUnidad: isGlobalBill ? 'ACT' : '',
    cantidad: 1,
    descripcion: isGlobalBill ? 'Venta' : '',
    valorUnitario: 0,
    descuento: 0,
    noIdentificacion: '',
    impuestos: [{
        type: 'iva',
        tipo: 'Fijo',
        retencion: false,
        tasa: 0.16,
        _uniqueId: 'IVA-TRAS-FIJO-TASA-0.16'
    }]
})))
